import LayoutTypeList       from 'containers/LayoutType/LayoutTypeList';
import standRoutes          from 'containers/Stand/StandRoutes';
import standDocumentsRoutes from 'containers/StandDocuments/StandDocumentRoutes';
import Account              from 'containers/Security/Account';
import Administrators       from 'containers/Security/Administrators';
import LegalMentions        from 'containers/LegalMentions/LegalMentions';
import PrivateRoute         from 'containers/PrivateRoute/PrivateRoute';
import showRoutes           from 'containers/Show/ShowRoutes';
import demandRoutes         from 'containers/Demand/DemandRoutes';
import advertiserRoutes     from 'containers/Advertiser/routes';
import providerRoutes       from 'containers/Provider/routes';
import NotFoundPage         from 'containers/NotFoundPage';
import ErrorPage            from 'containers/ErrorPage/ErrorPage';
import Login                from 'containers/Security/Login';
import PasswordForgotten    from 'containers/Security/PasswordForgotten';
import PasswordRecover      from 'containers/Security/PasswordRecover';
import SecurityGate         from 'containers/Security/SecurityGate';
import { Route }            from 'react-router-dom';
import { Routes }           from 'react-router-dom';

import GlobalStyle from 'styles/global-styles';

export default function App() {
  return (
    <div
      style={{
        display: 'flex',
        flex: 1,
      }}
    >
      <SecurityGate>
        <Routes>
          <Route element={<Login />} path="/login" />
          <Route element={<PasswordForgotten />} path="/mot-de-passe-oublie" />
          <Route element={<PasswordRecover />} path="/reinitialisation-mot-de-passe" />
          <Route element={<ErrorPage />} path="/erreur" />

          <Route element={<PrivateRoute />}>
            <Route element={<Administrators />} key="administrators" path="/administrateurs" />
            <Route element={<Account />} key="account" path="/compte" />
            <Route element={<LayoutTypeList />} key="layout-types" path="/layout-types" />
            <Route element={<LegalMentions />} key="legal-mentions" path="/mentions-legales" />
            {demandRoutes}
            {showRoutes}
            {standRoutes}
            {standDocumentsRoutes}
            {advertiserRoutes}
            {providerRoutes}
          </Route>

          <Route element={<NotFoundPage />} key="404" path="/404" />
          <Route element={<NotFoundPage />} path="*" />
        </Routes>
      </SecurityGate>
      <GlobalStyle />
    </div>
  );
}
